/* tslint:disable */
//  This file was automatically generated and should not be edited.

export enum ProductsOrderBy {
  CREATION = "CREATION",
  CREATION_DESC = "CREATION_DESC",
  PRICE = "PRICE",
  PRICE_DESC = "PRICE_DESC",
  UPDATED = "UPDATED",
}